<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Materials >> {{formtitle}}</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <b-field grouped group-multiline>
          <b-field
            class="column is-4"
            label="título"
            :type="{'is-danger': errors.has('titulo')}"
            :message="errors.first('titulo')"
          >
            <b-input 
              v-model="titulo" 
              v-validate="'required'" 
              name="titulo"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="descrição"
            :type="{'is-danger': errors.has('descricao')}"
            :message="errors.first('descricao')"
          >
            <b-input 
                v-model="descricao" 
                v-validate="'required'" 
                name="descricao"></b-input>
          </b-field>

          <b-field class="column is-4 uploadlabel material" label="Selecione o Arquivo">
            <b-upload v-model="fileSended" v-validate="'required'" accept="application/pdf" >
              <a class="button uploadbutton">
                <span>Selecionar arquivo</span>
              </a>
            </b-upload>
            <!-- https://developer.mozilla.org/pt-BR/docs/Web/API/File -->
            <span class="file-name" v-if="fileSended">{{ fileSended.name }}</span>
          </b-field>

          <b-field
            class="column is-4"
            label="Escola"
            :type="{'is-danger': errors.has('grade')}"
            :message="errors.first('grade')"
          >
            <multiselect
              v-model="material.escolas"
              tag-placeholder="Adiconar escola"
              placeholder="Conteudo disponível apenas:"
              label="name"
              track-by="id"
              :options="escolas"
              :multiple="true"
              :taggable="true"
            >
              
            </multiselect>
          </b-field>

          <b-field
            class="column is-4"
            label="Tag"
            :type="{'is-danger': errors.has('grade')}"
            :message="errors.first('grade')"
          >
            <multiselect
              v-model="material.tags"
              tag-placeholder="Adicionar tag"
              placeholder="Procure ou adicione uma tag"
              label="nome"
              track-by="id"
              :options="options"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            ></multiselect>
          </b-field>
        </b-field>

        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton" :disabled="!isFormValid">{{formtitle}}</button>
        </div>
      </form>
    </article>
  </div>
</template>
<script>
import EscolaService from "@/services/EscolaService";
//import MaterialService from "@/services/MaterialService";

/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
export default {
  name: "materialform",
  props: ["material", "formtitle"],
  data() {
    return {
      escolas: [],
      options: [],
      titulo: '',
      descricao: '',
      fileSended: {}
    };
  },
  created() {
    EscolaService.Index().then(result => {
      result.data.forEach(escola => {
        this.escolas.push({ name: escola.nome, id: escola.id });
      });
    });
    /*MaterialService.SearchTags().then(result => {
      result.forEach(tipo => {
        this.options.push(tipo);
      });
    });*/
  },
  watch: {
    material(newValue) {
      this.titulo = newValue.file.titulo;
      this.descricao = newValue.file.descricao;
      //this.escolas = newValue.escolas;
      //this.$forceUpdate();
    }
  },
  methods: {
    addTag(newTag) {
      const tag = {
        nome: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.material.tags.push(tag);
    },
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;
          
          self.material.titulo = self.titulo;
          self.material.descricao = self.descricao;
          self.material.file = self.fileSended;


          console.log(self.material.titulo);
          console.log(self.titulo);
          this.$emit("formSubmit", self.material, () => {});
        }
      });
    }
  },
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  }
};
</script>